$(function () {
	/* Navigation Menu */
	$('#nav-menu-toggle').on('click', function (e) {
		var $this = $(this);
		if ($this.hasClass('nav-active')) {
			$this
				.attr('aria-expanded', 'false')
				.add('#nav-menu').removeClass('nav-active');
		} else {
			$this
				.attr('aria-expanded', 'true')
				.add('#nav-menu').addClass('nav-active');
		}
	});

	/* Fix "Skip navigation links" to actually move focus */
	$('body').on('keydown.nav', 'a[href^="#"]', function (e) {
		var $target = $($(this).attr('href'));
		if ((e.keyCode === 13 || e.keyCode === 32) && $target.length) {
			if (!$target.attr('tabindex')) {
				$target.attr('tabindex', '-1').one('blur.nav', function () {
					$target.removeAttr('tabindex');
				});
			}
			$target.focus();
			return false;
		}
	});

	/* Search form */
	$('#artist-search-field')
		.on('focusin', function () {
			var focusTimer;
			$('.artist-search-form')
				.addClass('active')
				.on('focusout', function () {
					clearInterval(focusTimer);
					focusTimer = setInterval(function () {
						var focusedInSearch = $(':focus').closest('.artist-search-form').length > 0 || $('.autocompleteVisible:visible').length > 0;
						if (!focusedInSearch) {
							clearInterval(focusTimer);
							$('.artist-search-form').removeClass('active');
						}
					}, 100);
				});
		})
		.autocomplete({
			source: '/wp-json/get_artists/1.0.0/',
			key: 'name',
			minLength: 1,
			customDisplay: function (data) {
				// console.log('data', data);
				return {
					value: data.raw.name,
					display: '<a href="'+data.raw.url+'">'+data.raw.name+'</a>'
				};
			}
		});

	/* Make outlines only appear when using keyboard */
	$('body')
		.on('keydown.accessibility', function (e) {
			if (e.keyCode === 9) {
				$('html').removeClass('mouse');
			}
		})
		.on('mousedown.accessibility', function (e) {
			$('html').addClass('mouse');
		});

	/* Mailchimp Stuff */
	$('.updates-trigger').on('click', function () {
		$('.mc4wp-form').modal();
	});
	if (window.openModal && $('.mc4wp-response:not(:empty)').length) {
		$('.newsletter-form').addClass('hidden');
		$('.newsletter-sidebar .textwidget').html($('.sidebar-success:not(:empty)').html());
		$('.mc4wp-form').modal();
	}

	var shareHtml = $('.share-inner').first().html();
	$('.product-share')
		.one('click', function() {
			$(this)
				.after('<div class="social-product">'+shareHtml+'</div>')
				.on('click', function () {
					$(this).next().toggleClass('hidden');
				});
		});
	$('.categorized-products a').on('click', function () {
		var html = $(this).closest('li').prop('outerHTML');
		var $featured = $('#featured-product');
		$featured.html(html).find('.carouselSlide').removeClass('carouselSlide');
		$('html, body').animate({
			scrollTop: $featured.offset().top
		}, 500);
		return false;
	});

	/* Contact Page */
	if ($('.contact-form').length) {
		function handle_failure($contactResponse, response) {
			$contactResponse
				.removeClass('loading')
				.html(response.message);
		}
		var $contactForm = $('.contact-form'),
			$response = $('#contact-response'),
			$required_fields = $('#name'),
			$submitButton = $('#contact-send');
		$contactForm.on('submit', function () {
			var errors = 0,
				count = 0,
				sendingTimer;
			if ($submitButton.data('prevent-submit') === true || $('#email2').val().length) {
				return false;
			}
			$required_fields.each(function () {
				var $this = $(this),
					val = $this.val();
				if (val.length < 1) {
					$this.addClass('error');
					errors++;
				} else {
					$this.removeClass('error');
				}
			});
			if (errors > 0) {
				$response.html('Please fix the above errors.');
				return false;
			}
			$response
				.html('')
				.addClass('loading');
			$submitButton
				.data('send-message', $submitButton.val())
				.val($submitButton.data('sending'))
				.data('prevent-submit', true);
			sendingTimer = setInterval(function () {
				if (count >= 3) {
					$submitButton.val($submitButton.data('sending'));
					count = 0;
				} else {
					$submitButton.val($submitButton.val() + '.');
				}
				count++;
			}, 750);
			$('#submission').val('ajax');
			$.ajax({
				type: "POST",
				url: $contactForm.attr('action'),
				data: $contactForm.serialize(),
				dataType: 'json',
				success: function (response) {
					if (response.status === 'success') {
						$contactForm.addClass('contact-sent');
						$response
							.html($response.data('success'))
							.addClass('contact-success')
							.removeClass('loading');
						$required_fields.removeClass('error')
					} else {
						handle_failure($response, response);
					}
					clearInterval(sendingTimer);
					$submitButton
						.val($submitButton.data('send-message'))
						.data('prevent-submit', false);
				},
				error: function(response) {
					handle_failure($response, response);
					clearInterval(sendingTimer);
					$submitButton
						.val($submitButton.data('send-message'))
						.data('prevent-submit', false);
				}
			});
			return false;
		});
		$contactForm.append('<div class="hide-visually"><label for="email2">Your Second Email (Do not fill out. Used for spam.)</label><input id="email2" name="email2" tabindex="-1" type="text" value="" /><input id="submission" name="submission" type="hidden" value="ajax"></div>');
	}

	/****************************************
		Artist gallery page
	*****************************************/
	var $carousels = $('.carousel');
	if ($carousels.length) {
		$carousels.find('.carouselInner > li').addClass('carouselSlide');
		$carousels.carousel({
			fullWidth: false,
			showPreviews: true
		});
	}
});